import React from 'react';
import { MdArrowForward } from 'react-icons/md';
import useCustomNavigate from '../../../hooks/useCustomNavigate';

function PropertiesHeaderSection({ headerTitle = 'Popular Owner Properties', buttonText = 'See all Properties', navigateTo = '/allproperties/jaipur' }) {
  const { goToNewTab } = useCustomNavigate();

  return (
    <div className="flex flex-col md:flex-row items-start md:items-center justify-between py-4 px-4 md:px-8 space-y-2 md:space-y-0">
      <div>
        <h2 className="text-lg md:text-2xl font-medium text-white">{headerTitle}</h2>
        <div className="w-8 h-1 bg-yellow-400 mt-1"></div>
      </div>
      <button
        onClick={() => {
          goToNewTab(navigateTo);
        }}
        className="text-orange-600 hover:text-red-600 flex items-center font-semibold transition duration-300 group cursor-pointer"
        style={{
          cursor:"pointer"
        }}
      >
        {buttonText}
        <MdArrowForward className="ml-1 transition-transform duration-300 group-hover:translate-x-1" />
      </button>
    </div>
  );
}

export default PropertiesHeaderSection;
